import { render } from "./refund-info.vue?vue&type=template&id=27b7e5ea&scoped=true"
import script from "./refund-info.vue?vue&type=script&lang=js"
export * from "./refund-info.vue?vue&type=script&lang=js"

import "./refund-info.vue?vue&type=style&index=0&id=27b7e5ea&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b7e5ea"]])

export default __exports__